/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateProfileCountsDataSchema = z.object({
	workHistory: z.number().default(0),
	education: z.number().default(0),
	licenses: z.number().default(0),
})

export type CandidateProfileCountsDataSchema = z.infer<typeof candidateProfileCountsDataSchema>
